import { toNumberString } from '@client/toolkit';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa6';
import classNames from 'classnames';

export const PercentChange = ({ value }: { value: number }) => {
  return (
    <span
      className={classNames(value > 0 ? `text-[#10B981]` : `text-[#FF7E68]`, 'flex justify-end items-center gap-1')}
    >
      {toNumberString(value)}% {value !== 0 ? value > 0 ? <FaArrowUp /> : <FaArrowDown /> : null}
    </span>
  );
};
